var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kr-brand-selector", class: _vm.dynamicClasses },
    [
      _c("div", { staticClass: "kr-brand-selector-wrapper" }, [
        _c("div", { staticClass: "kr-arrow" }),
        _c(
          "ul",
          {
            ref: "menu",
            staticClass: "kr-brand-selector-list",
            attrs: {
              role: "menu",
              tabindex: "-1",
              id: _vm.menuUid,
              "aria-labelledby": _vm.buttonUid,
              "aria-activedescendant": _vm.activeItemUid,
            },
            on: { keydown: _vm.onKeydown },
          },
          _vm._l(_vm.configList, function (config, idx) {
            return _c(
              "li",
              {
                class: _vm.computeClasses(config),
                attrs: {
                  role: "menuitem",
                  tabindex: "-1",
                  id: config.uid,
                  "aria-label": config.brand,
                  "data-forced-brand": config.brand.toLowerCase(),
                },
                on: {
                  click: function ($event) {
                    return _vm.onClick(config.brand)
                  },
                  touchend: function ($event) {
                    return _vm.onClick(config.brand)
                  },
                },
              },
              [
                config.icon
                  ? _c("SvgImage", {
                      attrs: {
                        "aria-labelledby": config.uid,
                        title: config.brand,
                        decorative: false,
                        template: config.icon,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }